import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { liveQuery } from 'dexie';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NavController, Platform, IonContent, ModalController } from '@ionic/angular';
import { forkJoin } from 'rxjs';
import { AppService } from 'src/app/services/app.service';
import { FileSystemService } from 'src/app/services/file-system.service';
import { tempDynamicStoreconfig } from 'src/app/shared/tempDynamicStoreconfig';
import { IdbService } from '../../../services/idb.service';
import { AsyncUtilityService } from 'src/app/services/async-utility.service';
import { AppEnum } from 'src/app/appenum';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from 'src/app/app.settings';
import { EncryptionService } from 'src/app/services/encryption.service';
import { environment } from 'src/environments/environment';
import { PermissionMessageComponent } from 'src/app/shared/permission-message/permission-message.component';
import { PermissionService } from 'src/app/services/permission.service';
import { take } from 'rxjs/operators';
import { AppNavigation } from 'src/app/services/app-navigation';
import { ValidationAlertComponent } from 'src/app/shared/validation-alert/validation-alert.component';
import { LoggingService } from 'src/app/services/logging.service';
import { wrapAllMethodsWithLogging } from 'src/app/core/decorators/log-all-errors.decorator';
@Component({
  selector: 'app-task-summary',
  templateUrl: './task-summary.component.html',
  styleUrls: ['./task-summary.component.scss'],
  standalone: false
})
export class TaskSummaryComponent implements OnInit {
  @HostListener("window:scroll", [])
  public componentName = "TaskSummaryComponent";
  @ViewChild(IonContent, { static: true }) content: IonContent;
  public isDataLoading = true;
  public backButtonSubscription;
  public taskId;
  public lat;
  public long;
  public allRecomendedandMandetoryControls = []
  public taskDetails;
  public zoneImageList = [];
  public visibleZone;
  public selectedImage = [];
  public OrgName = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.OrgName));
  public isZoneQuestion = false;
  public loggedInUserName = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.username));
  username: any;
  public finalvalidationList = {};
  public totalValidation = 0;
  ShowSpinner = false;
  public isDataLoaded = false;
  InspectionTaskDetails: any;
  public submitEvent = false;
  public isOpenFeedBackQues = true;
  public updatedFieldsforCustomForm: any;
  isbtndisabled = false;
  checkuploadingimage: any;
  imageList: any[];
  fileMetaData: any;
  public isTaskChecklistQues = true;
  public customTaskChecklist = this._tempDynamicFormConfig.taskChecklist;
  ZonechecklistValue: any = [];
  taskCheckListValueToSubmit: any = [];
  ZoneLevelQuesValue: any = [];
  templatesData: any = [];
  imagesTodelete: any = [];
  zoneKeys = [];
  submitlaterText: any;
  beforedeleteWarningMsg: any;
  deleteWarningMsg: any;
  cancelText: any;
  yesText: any;
  continueText: any;
  missingText: any;
  missingrecomended: any;
  validation_pre_text: any;
  mendatoryText: any;
  recomendedText: any;
  suggestionText: any;
  HiText: any;
  confirmText: any;
  showData = false;
  selectedLang: any;
  deleteSuccessMessage: any;
  showGoBottombtn = false;
  showingProgress = false;
  zoneNames;
  uniqueControlIds: any[];
  viewMoreState: { [key: string]: boolean } = {};
  channel: any;
  showFullText: boolean = false;
  showFullObservation: boolean = false;
  metaConfigData: any;

  @ViewChild(PermissionMessageComponent) permissionMessage!: PermissionMessageComponent;
  permissionDenied$ = this.permissionService.permissionDenied$;
  isZoneChecklistError: boolean = false;
  recommendedMediaPending: boolean = false;
  orgId: any;
  flatTemplateJson: any;
  isChecklistOpen: boolean = true;
  isImagePanel: boolean = false;
  isUpdating: boolean = false;
  deleteTitle: any;
  saveLaterTitle: any;
  saveNewBtn: any;
  deleteButton: any;


  pendingUploadFiles: any[] = [];
  showMediaUploadOverlay = false;
  // public pendingUploadSub?: Subscription;
  private pendingUploadSub?: { unsubscribe: () => void };
  public createdObjectUrls: string[] = [];
  estimatedTimeRemaining: string;
  constructor(public _tempDynamicFormConfig: tempDynamicStoreconfig, public _appenum: AppEnum, public _appServices: AppService,
    public _translateService: TranslateService,
    public _appSetting: AppSettings,
    public _fileSystem: FileSystemService, public _activatedroute: ActivatedRoute, public _nav: AppNavigation,
    public platform: Platform, public idbservice: IdbService, public sanitizer: DomSanitizer, public _asyncUtilityService: AsyncUtilityService,
    public appSetting: AppSettings, public encryptionService: EncryptionService,
    public permissionService: PermissionService,
    private _modalController: ModalController,
    private loggingService: LoggingService
  ) {
    wrapAllMethodsWithLogging(this, this.componentName);
    this.selectedLang = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale))
    this.username = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.username));
    this.checkuploadingimage = this.encryptionService.decrypt(this.encryptionService.sessionstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.isRunningAsyncUtility));
    this.submitlaterText = this._translateService.instant('self_pwa_text.submit_later_text');
    this.saveLaterTitle = this._translateService.instant('common_text.save_for_later_text');
    this.saveNewBtn = this._translateService.instant('common_text.save_new_btn');
    this.beforedeleteWarningMsg = this._translateService.instant('common_text.before_delete_confirmation_text');
    this.deleteWarningMsg = this._translateService.instant('common_text.delete_selected_text');
    this.deleteTitle = this._translateService.instant('common_text.delete_title_text');
    this.deleteButton = this._translateService.instant('common_text.delete_btn');
    this.cancelText = this._translateService.instant('common_btn_text.cancel_btn');
    this.yesText = this._translateService.instant('common_btn_text.yes_btn');
    this.HiText = this._translateService.instant('common_text.hi_text');
    this.validation_pre_text = this._translateService.instant('common_text.validation_pre_text');
    this.mendatoryText = this._translateService.instant('common_text.validation_mandetory_text');
    this.recomendedText = this._translateService.instant('common_text.validation_recomended_text');
    this.missingText = this._translateService.instant('common_text.validation_mid_text');
    this.suggestionText = this._translateService.instant('common_text.validation_suggestion_text');
    this.missingrecomended = this._translateService.instant('common_text.validation_pre_mid_text');
    this.continueText = this._translateService.instant('common_text.validation_text');
    this.confirmText = this._translateService.instant('common_alert_text.confirm_title_text');

  }

  ngOnInit() {
    const currentQueryParam = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.hashKey))
    this._appServices.setCookie('authToken', this.encryptionService.encrypt(this._appenum.EntityOfLocalStorageKeys.authtoken), 15, currentQueryParam);
    this.metaConfigData = JSON.parse(this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.channelConfignData)));
    this.channel = this.metaConfigData.is_meta_data_enable;
    this.zoneNames = JSON.parse(this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.zoneMasterData)))
    this.taskId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.taskId));
    this.orgId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.orgId))
    // this.lat = this._activatedroute.snapshot.paramMap.get('latitude');
    // this.long = this._activatedroute.snapshot.paramMap.get('longitude');
    this.lat = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.latitude));
    this.long = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.longitude));
    this._appServices.removeBackHistory(true, 'noexit');
    this.backButtonSubscription = this._appServices.isBackButtonlicked.subscribe(_isBackClicked => {
      if (_isBackClicked.doaction == 'noexit') {
        setTimeout(() => {
          this._nav.navigateRoot(
            `/user-panel/tasks/start-inspection-form`,
            {
              state: {
                previousComponent: 'taskSummary',
                latitude: this.lat,
                longitude: this.long,
                taskId: this.taskId
              }
            }
          );
        }, 100);
      }
    });


    if (this._appSetting.taskData && this._appSetting.taskData.TaskId == this.taskId) {
      this.taskDetails = this._appSetting.taskData;
      this.getDataFromLocalDB();
    } else {
      this.getTaskData();
    }
  }

  async getTaskData() {
    var postJson = {
      "taskId": this.taskId,
    }
    var gettask = await this._appServices.postData(environment.endpoint.getTask, postJson);
    forkJoin([gettask]).subscribe(async (_res) => {
      var paramRequest1 = {
        httpRequest: {
          method: 'post',
          url: 'getTask',
          payLoad: postJson,
          response: {
            responseCode: _res[0].StatusCode,
            responseMsg: _res[0].Message,
            result: _res[0]
          },
          // executionTime: ""
        },
        taskDetails: ''
      }
      this._appServices.logsActivity(
        _res[0].StatusCode == 200
          ? this._appenum.EntityOfLogLevel.Info
          : this._appenum.EntityOfLogLevel.Error,
        'GetTask Api Call To Get Detail of Task',
        this.componentName, paramRequest1.httpRequest, paramRequest1.taskDetails, environment.endpoint.getTask);
      this.taskDetails = _res[0].StatusCode == '200' ? _res[0].Data[0] : [];
      this.getDataFromLocalDB();
    }, err => {
      var paramRequest = {
        httpRequest: {
          method: 'post',
          url: 'getTask',
          payLoad: postJson,
          response: {
            responseCode: err.status,
            responseMsg: err.message,
            result: err
          },
          // executionTime: ""
        },
        taskDetails: ''
      }
      this._appServices.logsActivity(this._appenum.EntityOfLogLevel.Error, 'GetTask Api Call To Get Detail of Task', this.componentName, paramRequest.httpRequest, paramRequest.taskDetails, environment.endpoint.getTask);
    });
  }
  async getDataFromLocalDB() {
    const [
      DynamicCardTaskTemplate,
      fileMetaData,
      taskImagesList,
      zoneLevelChecklist,
      zoneLevelChecklistTablecontrol,
      // taskLevelChecklist,
      // taskLevelChecklistTablecontrol
    ] = await Promise.all([
      this.idbservice.getDynamicCardTaskTemplateFromIdb(this.taskId),
      this.idbservice.getMetaDataDetailToUpload(this.taskId, this.orgId),
      this.idbservice.getDynamicCardImageFromIdb(this.taskId, this.orgId),
      this.idbservice.getChecklistFromIdb(this.taskId),
      this.idbservice.getChecklistTablecontrolFromIdb(this.taskId),
      // this.sqldbservices.getTaskLevelChecklistFromLocalDb(this.taskId),
      // this.sqldbservices.getTaskChecklistTablecontrolFromLocalDb(this.taskId)
    ]);
    this.fileMetaData = fileMetaData || [];
    if (zoneLevelChecklist && zoneLevelChecklist.status && zoneLevelChecklistTablecontrol && zoneLevelChecklistTablecontrol.status) {
      zoneLevelChecklist.data = zoneLevelChecklist.data.concat(zoneLevelChecklistTablecontrol.data || []);
    }
    this._tempDynamicFormConfig.zoneChecklistvalue = zoneLevelChecklist && zoneLevelChecklist.status ? zoneLevelChecklist.data : [];
    this._tempDynamicFormConfig.taskImagesList = taskImagesList && taskImagesList.status ? taskImagesList.data : [];
    this.updatedFieldsforCustomForm = this._tempDynamicFormConfig.serverData;
    console.log("this._tempDynamicFormConfig.serverData", this._tempDynamicFormConfig.serverData)
    console.log("updatedFieldsforCustomForm--------", this.updatedFieldsforCustomForm)
    this._tempDynamicFormConfig.fileMetaData = this.fileMetaData;
    // Simulate async loading process
    this._appServices.loaderDismiss();
    this._appServices.hideLoader()
    this.isDataLoaded = true;
    setTimeout(() => {
      this.getAllvalidation();
    }, 500);
  }

  getAllvalidation() {
    this._appServices.hideLoader()
    this.isDataLoading = false;
    this.getZoneWiseData();
  }
  // OLD WORKING CODE
  getZoneWiseData() {
    console.log("this._tempDynamicFormConfig", this._tempDynamicFormConfig)
    this.allRecomendedandMandetoryControls = [];
    this.isDataLoading = true;
    var zonesNamesList = this._tempDynamicFormConfig.GetAllZones();
    this.zoneImageList = [];
    this.totalValidation = 0;
    zonesNamesList.forEach(async (zone, i) => {
      this._tempDynamicFormConfig.jsonValueMapped(zone.templateId)
      this.imageList = await this._tempDynamicFormConfig.metaDataDetailMapped(zone.templateId, i);
      let zoneindex = this._tempDynamicFormConfig.serverData.findIndex(item => item.templateId == zone.templateId);
      let zoneImages = this.imageList.map(item => {
        let selectedControlDetails = this._tempDynamicFormConfig.getControlDetailsByControlId(zone.templateId, item.controlId)
        let selectedTierModels = this._tempDynamicFormConfig.childToParentTree(zone.templateId, selectedControlDetails)
        item['selectedTierModels'] = selectedTierModels;
        return item;
      });
      let reconmendedControlList = this._tempDynamicFormConfig.getRecomendendCOntrolList(zone.templateId).map(item => {
        let selectedControlDetails = this._tempDynamicFormConfig.getControlDetailsByControlId(zone.templateId, item.controlName)
        let selectedTierModels = this._tempDynamicFormConfig.childToParentTree(zone.templateId, selectedControlDetails)
        item['selectedTierModels'] = selectedTierModels;
        return item;
      })

      var zoneObj: any = { zoneName: zone, isCollapse: i == 0 ? false : true, zoneImages: zoneImages, reconmendedControlList: reconmendedControlList, zoneDetails: this._tempDynamicFormConfig.getTreeByZoneIndex(zoneindex) };
      zoneObj.zoneImages.forEach((img) => {
        img.LocalFileUrl = ''
      });

      zoneObj.uniqueControlIds = [...new Set(zoneObj.zoneImages.map((img) => img.controlId))];

      zoneObj.uniqueControlIds = zoneObj.uniqueControlIds.map((controlId) => {
        let selectedControlDetails = this._tempDynamicFormConfig.getControlDetailsByControlId(zone.templateId, controlId);
        let selectedTierModels = this._tempDynamicFormConfig.childToParentTree(zone.templateId, selectedControlDetails);

        return {
          controlId: controlId,
          selectedTierModels: selectedTierModels
        };
      });
      this.allRecomendedandMandetoryControls = [...this.allRecomendedandMandetoryControls, ...reconmendedControlList];
      this.zoneImageList.push(zoneObj);
      this.zoneImageList = this.zoneImageList.map(zone => {
        let hasMandatory = false;
        let hasRecommended = false;
        if (Array.isArray(zone?.reconmendedControlList)) {
          for (const item of zone.reconmendedControlList) {
            if (item?.mandatory === 1) {
              hasMandatory = true;
              break; // highest priority
            }
            if (item?.mandatory === 2) {
              hasRecommended = true;
            }
          }
        }
        return {
          ...zone,
          validationState: hasMandatory
            ? 'mandatory'
            : hasRecommended
              ? 'recommended'
              : null
        };
      });
      console.log("zoneImageList", this.zoneImageList)
    });
    this.isDataLoading = false;
    this.isZoneQuestion = this.updatedFieldsforCustomForm.some(item => item.templateQues.length > 0)
  }

  onPanelChange(isOpen: boolean) {
    if (isOpen && !this.isUpdating) {
      this.onImagePanelOpen();
    }
  }
  async onImagePanelOpen() {
    if (this.isUpdating) return;
    this.isUpdating = true;
    this.isChecklistOpen = false;
    setTimeout(async () => {
      await this.getDataFromLocalDB();
      this.isUpdating = false
    }, 0);
  }

  trackByZone(index, item) {
    return item.zoneName?.templateId || index;
  }

  ionViewWillLeave() {
    // if (this._tempDynamicFormConfig.checklistChanges) {
    //   this.saveSubmit();
    // }
    localStorage.removeItem('lastSelectSegment')
    this.backButtonSubscription.unsubscribe();
  }

  getFilteredImages(images, controlId: string): any[] {
    return images.filter(image => image.controlId == controlId) || [];
  }

  toggleViewMore(controlId: string): void {
    this.viewMoreState[controlId] = !this.viewMoreState[controlId];
  }

  // getValidationListZoneWise(zone) {
  //   var zoneIndex = this._tempDynamicFormConfig.getSelectedZoneIndex(zone);
  //   var validationList = this.finalvalidationList[this._tempDynamicFormConfig.serverDataKeys[zoneIndex]];
  //   return validationList;
  // }

  // collapseUncollapse(index, collapseValue) {
  //   this.zoneImageList.forEach(zone => {
  //     zone.isCollapse = true;

  //   });
  //   this.content.scrollToTop();
  //   this.zoneImageList[index].isCollapse = !collapseValue;
  // }

  checkedUnchecked(imgDetails, value) {
    if (value.target.checked) {
      this.selectedImage.push(imgDetails);

    } else {
      const index = this.selectedImage.indexOf(imgDetails);
      if (index > -1) {
        this.selectedImage.splice(index, 1);
      }
    }
  }

  async deleteConfirmation() {
    if (this.selectedImage.length == 0) {
      this._appServices.ionicCustomAlertwithgif('', '', this.beforedeleteWarningMsg);
      return;
    }
    const alert = await this._appServices._alertController.create({
      cssClass: 'Confirmation_popup',
      header: this.deleteTitle,
      message: this.deleteWarningMsg,
      // message: 'Please confirm if you wish to delete this file',
      buttons: [
        {
          text: this.cancelText,
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: this.deleteButton,
          handler: () => {
            this.deleteFromServer();
          }
        }
      ]
    });
    await alert.present();
  }

  async deleteFromServer() {
    this._appServices.showLoader()
    this.isDataLoading = true;
    this.selectedImage.forEach(key => {
      this.imagesTodelete.push(key.FileName)
    })
    const postJson = {
      taskId: this.taskId,
      fileName: this.imagesTodelete
    }
    const logRequest: any = {
      apiEndUrl: environment.endpoint.deleteMediaDetails,
      reqBody: postJson,
    };
    this._appServices.postDataWithPromise(environment.endpoint.deleteMediaDetails, postJson).then(async (res) => {
      this._appServices.hideLoader();
      this.loggingService.handleResponseLog(
        res.StatusCode == 200
          ? 'info'
          : res.StatusCode == 402
            ? 'warning'
            : 'error',
        logRequest,
        res.StatusCode,
        res.Message,
        'deleteMediaDetails Api Call To Delete Media From Summary Page',
        this.componentName,
        environment.endpoint.deleteMediaDetails
      );
      if (res.StatusCode == 200) {
        setTimeout(() => {
          this._appServices.presentToast(this._translateService.instant('common_text.file_delete_msg'));
        }, 500)
        for (const item of this.imagesTodelete) {
          try {
            const MetaFileDatailData: any = await this.idbservice.deleteMetaDataByFileName(item, this.taskId, this.orgId, 'inActive');
          } catch (error) {

          }
        }
        this.selectedImage = [];
        this.imagesTodelete = [];
        this.getDataFromLocalDB();
      } else if (res.StatusCode == 402) {
        for (const item of this.imagesTodelete) {
          try {
            const MetaFileDatailData: any = await this.idbservice.deleteMetaDataByFileName(item, this.taskId, this.orgId, 'inActive');
          } catch (error) {

          }
        }
        this.selectedImage = [];
        this.imagesTodelete = [];
        this.getDataFromLocalDB();
      } else {
        this._appServices.hideLoader()
        this.selectedImage = [];
        this.imagesTodelete = [];
        this.isDataLoading = false;
        this._appServices.presentToast(res.Message[this.appSetting.selectedLanguage] != undefined ? res.Message[this._appServices.selectedLanguage] : res.Message[this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.defaultLanguageSelected))]);
      }
    }, err => {
      this.loggingService.logApiError(
        'error',
        logRequest,
        err,
        'deleteMediaDetails Api Call To Delete Media From Summary Page',
        this.componentName,
        environment.endpoint.deleteMediaDetails
      )
      this._appServices.hideLoader()
      this.isDataLoading = false;
    })
  }

  async clearMediaValues(controls: any[]) {
    if (!Array.isArray(controls)) return;

    controls.forEach(control => {
      if (['photos', 'videos', 'files'].includes(control.controlType)) {
        if (Array.isArray(control.value)) {
          delete control['value']
        }
        if (control?.selectedTierModels && Array.isArray(control.selectedTierModels)) {
          delete control['selectedTierModels']
        }
      }
      // Case 2: Title → has children
      if (control.controlType === 'title' && Array.isArray(control.children)) {
        this.clearMediaValues(control.children); // recursion
      }
      // Optional: if other types also have children (safety)
      if (Array.isArray(control.children)) {
        this.clearMediaValues(control.children);
      }
    });
  }

  //Save and  Submit
  async saveSubmit(status = "inprogress") {
    this.ZonechecklistValue = []
    this.taskCheckListValueToSubmit = []
    var obj = {};
    for (var i = 0; i < this._tempDynamicFormConfig.serverData.length; i++) {

      this.flatTemplateJson = this._tempDynamicFormConfig.serverData[i].templateJson
      await this.clearMediaValues(this.flatTemplateJson);
      this.flatTemplateJson = this._appServices.validateAndRepairTemplateJson(
        this.flatTemplateJson,
        this._tempDynamicFormConfig.tempTemplateData,
        i,
        this._tempDynamicFormConfig.serverData[i].templateId,
        { componentName: this.componentName, taskId: this.taskId, logLevel: this._appenum.EntityOfLogLevel.Error }
      )
      console.log("this.flatTemplateJson", this.flatTemplateJson)
      this.ZoneLevelQuesValue = JSON.parse(JSON.stringify(this._tempDynamicFormConfig.serverData[i].templateQues))
      const zoneChecklist = this.ZoneLevelQuesValue.filter(itm => itm.controlvalue != '' && itm.controlType != 'table')
      zoneChecklist.forEach(item => {
        obj = {
          "TaskID": this.taskId,
          "controlName": item.controlName,
          "controlType": item.controlType,
          "controlvalue": item.controlvalue,
          "templateName": this._tempDynamicFormConfig.serverData[i].templateName,
          "templateId": this._tempDynamicFormConfig.serverData[i].templateId,
        }
        this.ZonechecklistValue.push(obj)
      })
      const zoneTableChecklist = this.ZoneLevelQuesValue.filter(itm => itm.controlType == 'table')
      zoneTableChecklist.forEach(item => {
        obj = {
          "TaskID": this.taskId,
          "controlName": item.controlName,
          "controlType": item.controlType,
          "controlvalue": item.tableData.value,
          "templateName": this._tempDynamicFormConfig.serverData[i].templateName,
          "templateId": this._tempDynamicFormConfig.serverData[i].templateId,
        }
        this.ZonechecklistValue.push(obj)
      });
      var templateData = {
        templateId: this._tempDynamicFormConfig.serverData[i].templateId,
        templateQues: this._tempDynamicFormConfig.serverData[i].templateQues,
        templateQuesValue: this.ZonechecklistValue.length > 0 ? this.ZonechecklistValue : null,
        templateJson: this.flatTemplateJson
      }
      this.zoneKeys.push(this._tempDynamicFormConfig.serverData[i].templateId)
      this.templatesData.push(templateData)
    }
    if (this._tempDynamicFormConfig.taskChecklist && this._tempDynamicFormConfig.taskChecklist.length > 0) {
      const taskLevelChecklist = this._tempDynamicFormConfig.taskChecklist.filter(itm => itm.controlvalue != '')
      taskLevelChecklist.forEach(item => {
        const obj = {
          "TaskID": this.taskId,
          "controlName": item.controlName,
          "controlType": item.controlType,
          "controlvalue": item.controlvalue,
        }
        this.taskCheckListValueToSubmit.push(obj)
      })
    }
    this.templatesData.forEach(item => {
      item.templateQuesValue = this.ZonechecklistValue.length > 0 ? this.ZonechecklistValue.filter(itm => itm.templateId == item.templateId) : null
    })
    const postJson = {
      userType: 'user',
      zones: { keys: this.zoneKeys },
      taskId: this.taskId,
      status: "inprogress",
      taskChecklist: { checklist_value: this.taskCheckListValueToSubmit.length > 0 ? this.taskCheckListValueToSubmit : null },
      templates: this.templatesData
    }
    var taskDetail = {
      TaskId: this.taskId,
      status: status
    };
    const agentId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentId));
    await this._appServices.prepareTaskTemplateDataforUpdate(
      postJson.templates,
      agentId,
      this.taskId
    );
    this.isDataLoading = true;
    this.ShowSpinner = true;
    // this._appServices.showLoader();
    await this._appServices.postDataWithPromise(environment.endpoint.addTaskTemplate, postJson).then((res: any) => {
      // this._appServices.hideLoader()
      this.isDataLoading = false;
      this.ShowSpinner = false;
      var paramRequest = {
        httpRequest: {
          method: 'post',
          url: 'addTaskTemplate',
          response: {
            responseCode: res.StatusCode,
            responseMsg: res.Message,
            result: res
          },
          // executionTime: ""
        },
        taskDetails: taskDetail
      }
      this._appServices.logsActivity(
        res.StatusCode == 200
          ? this._appenum.EntityOfLogLevel.Info
          : this._appenum.EntityOfLogLevel.Critical,
        `${res.StatusCode != '200' ? 'FRONTEND_ALERT ' : ' '} addTaskTemplate APi Call to Save & Submit Later Inspection`,
        this.componentName, paramRequest.httpRequest, paramRequest.taskDetails, environment.endpoint.addTaskTemplate);

      if (res.StatusCode == '200') {
        // this.getZoneWiseData();
      } else {
        this._appServices.presentToast(res.Message[this.appSetting.selectedLanguage] != undefined ? res.Message[this._appServices.selectedLanguage] : res.Message[this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.defaultLanguageSelected))]);
        this._nav.navigateRoot(['verify-otp']);
        window.location.reload();
      }
    }, (err) => {
      console.log("err", err)
      this.isDataLoading = false;
      this.ShowSpinner = false;
      // this._appServices.hideLoader()
      var paramRequest = {
        httpRequest: {
          method: 'post',
          url: 'addTaskTemplate',
          // payLoad : postJson,
          response: {
            responseCode: err.status,
            responseMsg: err.message,
            result: err
          },
          // executionTime: ""
        },
        taskDetails: taskDetail
      }
      this._appServices.logsActivity(this._appenum.EntityOfLogLevel.Critical, 'FRONTEND_ALERT addTaskTemplate APi Call to Save & Submit Later Inspection',
        this.componentName, paramRequest.httpRequest, paramRequest.taskDetails, environment.endpoint.addTaskTemplate);
    });
  }

  async goToInspectionFormFill(imageZoneDetails, tempId) {
    const canNavigate = await this.checkLocationPermissionToNavigate();
    if (canNavigate) {
      let selectedCOntrolDetails = { templateId: tempId, UniqueControlId: imageZoneDetails.controlName }
      this._nav.navigateRoot(['user-panel/tasks/inspection-form-fill', { taskId: this.taskId, latitude: this.lat, longitude: this.long, fileId: 0, clickedZone: JSON.stringify(selectedCOntrolDetails), pageName: 'Task-summary' }]);
    }
  }

  // async isFileUploadInProgress() {
  //   var InspectionFileData: any = await this.idbservice.getTaskFileDetailsToUpload(this.taskId, this._appServices.UploadMaxRetryHit, this.orgId);
  //   this._appServices.logsActivity(this._appenum.EntityOfLogLevel.Info, 'InspectionFileData Self App' + ' ' + JSON.stringify(InspectionFileData), this.componentName);
  //   if (InspectionFileData.length > 0) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }


  async saveandsubmitlater() {
    this.checkuploadingimage = this.encryptionService.decrypt(this.encryptionService.sessionstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.isRunningAsyncUtility));
    if (await this.isFileUploadInProgress()) {
      return;
    }
    const alert = await this._appServices._alertController.create({
      cssClass: 'Confirmation_popup',
      header: this.saveLaterTitle,
      message: this.submitlaterText,
      buttons: [
        {
          text: this.cancelText,
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: this.saveNewBtn,
          handler: async () => {
            await this.saveSubmit();
            this._nav.navigateRoot(['user-panel/tasks/success', { isDataSave: true, tasksubmit: 'false' }]);
          }
        }
      ]
    });
    await alert.present();
  }

  async confirmationSave(e = null) {
    const quesErrorTemplateIds = new Set<string>();
    let templateData = this._tempDynamicFormConfig.serverData;
    let hasError = false;
    templateData.forEach((item, i) => {
      item.hasError = false;
      item.templateQues.forEach((ques, j) => {
        let isControlValueEmpty = false;
        if (Array.isArray(ques.controlvalue)) {
          isControlValueEmpty = ques.controlvalue.length === 0;
        } else {
          isControlValueEmpty = ques.controlvalue?.trim?.() === '';
        }
        if (
          ques.isRequired &&
          isControlValueEmpty &&
          (!ques.visibleOn || (Array.isArray(ques.visibleOn) && ques.visibleOn.includes(this._appServices.appType)))
        ) {
          hasError = true;
          ques.hasError = true;
          item.hasError = true;
          this.isZoneChecklistError = true;
          quesErrorTemplateIds.add(item.templateId);
        }
      });
    });

    // ── merge quesError into zoneImageList ──────────────────
    this.zoneImageList = this.zoneImageList.map(zone => {
      const hasQuesError = quesErrorTemplateIds.has(zone.zoneName?.templateId);

      let hasMandatoryMedia = false;
      let hasRecommended = false;
      if (Array.isArray(zone?.reconmendedControlList)) {
        for (const item of zone.reconmendedControlList) {
          if (item?.mandatory === 1) { hasMandatoryMedia = true; break; }
          if (item?.mandatory === 2) { hasRecommended = true; }
        }
      }

      return {
        ...zone,
        hasQuesError,
        validationState: hasMandatoryMedia || hasQuesError
          ? 'mandatory'
          : hasRecommended
            ? 'recommended'
            : null
      };
    });

    // ── pending zones to show in modal ──────────────────────
    const pendingZones = this.zoneImageList.filter(
      zone => zone.validationState === 'mandatory'
    );

    console.log("pendingZones", pendingZones);

    // ── message building (unchanged) ────────────────────────
    var message = '';
    let mandetoryCount = this.allRecomendedandMandetoryControls.filter(item => item.mandatory == 1).length;
    let recomendedCount = this.allRecomendedandMandetoryControls.filter(item => item.mandatory != 1).length;
    let missingMandatoryText = '';
    let missingRecommendedText = '';
    let formErrorText = '';
    let greeting = `${this.HiText} ${this.loggedInUserName},`;

    if (mandetoryCount > 0) {
      missingMandatoryText = `${mandetoryCount} ${this._translateService.instant('common_text.missing_mandatory_text')}, `;
    }
    if (recomendedCount > 0) {
      this._tempDynamicFormConfig.highlightcontrols = true;
      missingRecommendedText = `${recomendedCount} ${this._translateService.instant('common_text.missing_recommended_text')}`;
    }
    if (hasError) {
      formErrorText = ` ${this._translateService.instant('common_text.mandatory_fields_missing_text')}`;
    }

    if (mandetoryCount > 0 || hasError) {
      this._tempDynamicFormConfig.highlightcontrols = true;
      message = this._translateService.instant('self_pwa_text.mandatory_text', { userName: this.loggedInUserName });
    } else if (recomendedCount > 0) {
      message = this._translateService.instant('self_pwa_text.recmnd_text', { userName: this.loggedInUserName });
      // message = `Hi, there is some more recommended information which would be helpful for us`;
    } else {
      message = this._translateService.instant('self_pwa_text.sure_to_submit');
    }
    // this.customALert(message, mandetoryCount, hasError, pendingZones);
    this.customALert(message, mandetoryCount, hasError, pendingZones, recomendedCount);
  }
  async customALert(message: string, mandetoryCount: number, isRequiredQuestionPending: boolean, pendingZones: any[] = [], recomendedCount: number = 0) {
    const isMandatory = mandetoryCount > 0 || isRequiredQuestionPending;
    const cssClass = isMandatory
      ? 'validation-alert-modal mandatory-modal'
      : 'validation-alert-modal simple-modal';
    const modal = await this._modalController.create({
      component: ValidationAlertComponent,
      cssClass: cssClass,
      breakpoints: [0, 1],
      initialBreakpoint: 1,
      componentProps: {
        message,
        mandetoryCount,
        isRequiredQuestionPending,
        zoneImageList: pendingZones,
        recomendedCount,
        confirmText: this.confirmText
      }
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data?.action === 'submit') {
      this.checkTncAndNavigate(); // submit without filling OR confirm
    }
    // fill now / ok / dismiss → do nothing, user goes back
  }

  checkTncAndNavigate() {
    const showTermCondition = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.showTncPage));
    if (showTermCondition) {
      this._nav.navigateRoot(['user-panel/tasks/final-observation', { taskId: this.taskId }]);
    } else {
      this.submitInspection();
    }
  }

  async submitInspection() {
    this._appServices.showLoader()
    this.templatesData = [];
    this.ShowSpinner = true;
    this.isDataLoading = true;
    var status = "complete";
    var obj = {};
    var taskDetail = {
      TaskId: this.taskId,
      status: status
    }
    for (var i = 0; i < this._tempDynamicFormConfig.serverData.length; i++) {
      this.flatTemplateJson = this._tempDynamicFormConfig.serverData[i].templateJson
      await this.clearMediaValues(this.flatTemplateJson);
      this.flatTemplateJson = this._appServices.validateAndRepairTemplateJson(
        this.flatTemplateJson,
        this._tempDynamicFormConfig.tempTemplateData,
        i,
        this._tempDynamicFormConfig.serverData[i].templateId,
        { componentName: this.componentName, taskId: this.taskId, logLevel: this._appenum.EntityOfLogLevel.Error }
      )
      console.log("flatTemplateJson", this.flatTemplateJson)
      this.ZoneLevelQuesValue = JSON.parse(JSON.stringify(this._tempDynamicFormConfig.serverData[i].templateQues))
      const zoneChecklist = this.ZoneLevelQuesValue.filter(itm => itm.controlvalue != '' && itm.controlvalue != undefined && itm.controlType != 'table')
      zoneChecklist.forEach(item => {
        obj = {
          "TaskID": this.taskId,
          "controlName": item.controlName,
          "controlType": item.controlType,
          "controlvalue": item.controlvalue,
          "templateName": this._tempDynamicFormConfig.serverData[i].templateName,
          "templateId": this._tempDynamicFormConfig.serverData[i].templateId,
        }
        if (item.controlType == 'select' || item.controlType == 'radio') {
          // controlvalue is a single id (string)
          const matchedOption = item.controlOptions?.find(opt => opt.id === item.controlvalue);
          obj["value"] = matchedOption ? matchedOption.option : null;

        } else if (item.controlType == 'checkbox') {
          // controlvalue is an array of ids
          const matchedOptions = item.controlOptions?.filter(opt => item.controlvalue?.includes(opt.id)) || [];
          obj["value"] = matchedOptions.map(opt => opt.option);
        }
        this.ZonechecklistValue.push(obj)
      })
      const zoneTableChecklist = this.ZoneLevelQuesValue.filter(itm => itm.controlType == 'table')
      zoneTableChecklist.forEach(item => {
        obj = {
          "TaskID": this.taskId,
          "controlName": item.controlName,
          "controlType": item.controlType,
          "controlvalue": item.tableData.value,
          "templateName": this._tempDynamicFormConfig.serverData[i].templateName,
          "templateId": this._tempDynamicFormConfig.serverData[i].templateId,
        }
        this.ZonechecklistValue.push(obj)
      });
      var templateData = {
        templateId: this._tempDynamicFormConfig.serverData[i].templateId,
        templateQues: this._tempDynamicFormConfig.serverData[i].templateQues,
        templateQuesValue: this.ZonechecklistValue.length > 0 ? this.ZonechecklistValue : null,
        templateJson: this.flatTemplateJson
      }
      this.zoneKeys.push(this._tempDynamicFormConfig.serverData[i].templateId)
      this.templatesData.push(templateData)
    }
    this.templatesData.forEach(item => {
      item.templateQuesValue = this.ZonechecklistValue.length > 0 ? this.ZonechecklistValue.filter(itm => itm.templateId == item.templateId) : null
    })
    const postJson = {
      userType: 'user',
      languageCode: this._appSetting.selectedLanguage,
      zones: { keys: this.zoneKeys },
      taskId: this.taskId,
      status: 'complete',
      templates: this.templatesData
    };
    console.log("postJson of SUbmit inspection", postJson);

    (await this._appServices.postData(environment.endpoint.addTaskTemplate, postJson)).subscribe((res: any) => {

      var paramRequest = {
        httpRequest: {
          method: 'post',
          url: 'addTaskTemplate',
          payLoad: postJson,
          response: {
            responseCode: res.StatusCode,
            responseMsg: res.Message,
            result: res
          },
          // executionTime: ""
        },
        taskDetails: taskDetail
      }
      this._appServices.logsActivity(
        res.StatusCode == 200
          ? this._appenum.EntityOfLogLevel.Info
          : this._appenum.EntityOfLogLevel.Critical,
        `${res.StatusCode != '200' ? 'FRONTEND_ALERT ' : ' '} addTaskTemplate Api call to submit inspection`,
        this.componentName, paramRequest.httpRequest, paramRequest.taskDetails, environment.endpoint.addTaskTemplate);
      if (res.StatusCode == '200') {
        if (status == "complete") {
          let taskId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.taskId))
          let orgId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.orgId))
          const key = `inspectionSubmitted_${taskId}_${orgId}`;
          localStorage.setItem(key, Date.now().toString());
          this._appServices.deleteCookie('authToken');
          this.deleteTaskFilesFromLocal(res.Message);
        }
      } else {
        this._appServices.hideLoader()
        this.ShowSpinner = false;
        this.isDataLoading = false;
        this._appServices.presentToast(res.Message[this._appSetting.selectedLanguage] != undefined ? res.Message[this._appSetting.selectedLanguage] : res.Message[this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.defaultLanguageSelected))]);
        this._nav.navigateRoot(['verify-otp']);
        window.location.reload();
      }
    }, (err) => {
      this._appServices.hideLoader()
      this.ShowSpinner = false;
      this.isDataLoading = false;
      var paramRequest = {
        httpRequest: {
          method: 'post',
          url: 'addTaskTemplate',
          payLoad: postJson,
          response: {
            responseCode: err.status,
            responseMsg: err.message,
            result: err
          },
          // executionTime: ""
        },
        taskDetails: taskDetail
      }
      this._appServices.logsActivity(this._appenum.EntityOfLogLevel.Critical, 'FRONTEND_ALERT addTaskTemplate Api call to submit inspection', this.componentName, paramRequest.httpRequest, paramRequest.taskDetails, environment.endpoint.addTaskTemplate);
      this._appServices.presentToast(err);
    });
  }


  async deleteTaskFilesFromLocal(Message) {
    // this._appServices.deleteAgentDataByTaskId(this.taskId)
    await this.idbservice.deleteTaskFilesFromLocal(this.taskId, this.orgId);
    // await this.idbservice.deleteDatabase();
    this._tempDynamicFormConfig.serverData = undefined;
    this._tempDynamicFormConfig.taskImagesList = undefined;
    this._tempDynamicFormConfig.fileMetaData = undefined;
    this._nav.navigateRoot(['user-panel/tasks/success', { taskId: this.taskId, tasksubmit: 'true' }]);
    this._appServices.hideLoader()
    this.ShowSpinner = false;
    this.isDataLoading = false;
  }

  // feedbackcheckedUnchecked(imgDetails, value) {
  //   if (this._tempDynamicFormConfig.noCatImageReason == "" || this._tempDynamicFormConfig.noCatImageReason == null) {
  //     this._tempDynamicFormConfig.noCatImageReason = [];
  //   }
  //   if (value.target.checked) {
  //     this._tempDynamicFormConfig.noCatImageReason.push({
  //       "name": imgDetails.name,
  //       "controlName": imgDetails.controlName,
  //       "parent": imgDetails.parent,
  //       "value": value.target.value

  //     });
  //   } else {
  //     const index = this._tempDynamicFormConfig.noCatImageReason.findIndex(ele =>
  //       imgDetails.name == ele.name
  //       && ele.controlName == imgDetails.controlName
  //       && ele.parent == imgDetails.parent
  //       && ele.value == value.target.values
  //     );
  //     if (index > -1) {
  //       this._tempDynamicFormConfig.noCatImageReason.splice(index, 1);
  //     }
  //   }
  //   this.idbservice.updateTaskNoReason(this.taskId, this._tempDynamicFormConfig.noCatImageReason);
  // }

  // isCheckedReason(item, val) {
  //   if (this._tempDynamicFormConfig.noCatImageReason && this._tempDynamicFormConfig.noCatImageReason.length > 0) {
  //     return this._tempDynamicFormConfig.noCatImageReason.filter(ele => item.name == ele.name && val == ele.value).length > 0
  //   }
  //   else {
  //     return false;
  //   }
  // }

  GotoGalleryImageDetails(imgDetails: any) {
    let obj = {
      "orgid": imgDetails.orgid,
      "TaskId": imgDetails.TaskId,
      "controlId": imgDetails.controlId,
      "ObservationText": imgDetails.ObservationText,
      "ServerFileName": imgDetails.ServerFileName,
      "uploadedby": imgDetails.uploadedby,
      "MetaData": imgDetails.MetaData,
      "FileName": imgDetails.FileName,
      "LocalFileUrl": imgDetails.LocalFileUrl,
      "ServerFileUrl": imgDetails.ServerFileUrl,
      "FileType": imgDetails.FileType,
      "PhotoCategory": imgDetails.PhotoCategory,
      "zone": imgDetails.zone
    }
    this._tempDynamicFormConfig.serverUrl = imgDetails.ServerFileUrl;
    let selectedCOntrolDetails = { templateId: imgDetails.selectedTierModels[0].templateId, UniqueControlId: imgDetails.controlId };
    this._nav.navigateRoot(['user-panel/tasks/inspection-form-fill', { taskId: this._activatedroute.snapshot.paramMap.get('taskId'), latitude: this.lat, longitude: this.long, fileId: 1, fileDetail: JSON.stringify(obj), fileName: imgDetails.serverfilename, clickedZone: JSON.stringify(selectedCOntrolDetails), pageName: 'Task-summary' }]);
  }


  gotoPhotoMetaTag(imgDetails: any) {
    let obj = {
      // "orgid": imgDetails.orgid,
      "TaskID": imgDetails.TaskID,
      "controlId": imgDetails.controlId,
      "observationText": imgDetails.observationText,
      "serverFileName": imgDetails.serverFileName,
      "uploadedby": imgDetails.uploadedby,
      "MetaData": imgDetails.MetaData,
      "FileName": imgDetails.FileName,
      // "LocalFileUrl": imgDetails.localFileUrl,
      "ServerFileUrl": imgDetails.ServerFileUrl,
      "FileType": imgDetails.FileType,
      "photoCategory": imgDetails.photoCategory,
      "zoneName": imgDetails.zoneName ? imgDetails.zoneName : imgDetails.selectedTierModels[0].templateId
    }
    this._tempDynamicFormConfig.serverUrl = imgDetails.localFileUrl;
    this._tempDynamicFormConfig.FileName = imgDetails.FileName;
    this._tempDynamicFormConfig.originalFileName = imgDetails.originalFileName;
    let selectedCOntrolDetails = { templateId: imgDetails.zoneName ? imgDetails.zoneName : imgDetails.selectedTierModels[0].templateId, UniqueControlId: imgDetails.controlId };
    this._nav.navigateRoot(['user-panel/tasks/inspection-form-fill', { taskId: this._activatedroute.snapshot.paramMap.get('taskId'), latitude: this.lat, longitude: this.long, fileId: 1, fileDetail: JSON.stringify(obj), fileName: imgDetails.serverfilename, clickedZone: JSON.stringify(selectedCOntrolDetails), pageName: 'Task-summary' }]);
  }
  back_to_inspection(taskId, lat, long) {
    // if (this._tempDynamicFormConfig.checklistChanges) {
    //   this.saveSubmit();
    // } else {
    //   this._nav.navigateRoot(
    //     `/user-panel/tasks/start-inspection-form`,
    //     {
    //       state: {
    //         previousComponent: 'taskSummary',
    //         latitude: this.lat,
    //         longitude: this.long,
    //         taskId: this.taskId
    //       }
    //     }
    //   );
    // }
    this._nav.navigateRoot(
      `/user-panel/tasks/start-inspection-form`,
      {
        state: {
          previousComponent: 'taskSummary',
          latitude: this.lat,
          longitude: this.long,
          taskId: this.taskId
        }
      }
    );
  }

  getZoneName(templateId) {
    return this.zoneNames.filter(item => item.templateId == templateId)[0].ZoneName[this._appSetting.selectedLanguage]
  }

  formatMetaData(metaData: string | any[]): string {
    if (!metaData || metaData === "[]") {
      return ''; // Handle empty metadata
    }
    try {
      // Parse JSON string if it's not already an array
      if (typeof metaData === 'string') {
        const parsed = JSON.parse(metaData);
        if (Array.isArray(parsed)) {
          return parsed.join(', ');
        }
      }
      // If it's already an array
      if (Array.isArray(metaData)) {
        return metaData.join(', ');
      }
    } catch (error) {
      console.error('Error parsing MetaData:', error);
    }
    return metaData.toString();
  }


  checkLocationPermissionToNavigate(): Promise<boolean> {
    return new Promise((resolve) => {
      this.permissionDenied$.pipe(take(1)).subscribe(permissionDenied => {
        if (permissionDenied) {
          if (this.permissionMessage) {
            this.permissionMessage.shakeMessage();
          }
          resolve(false);
        } else {
          resolve(true);
        }
      });
    });
  }
  async onTemplateQuesUpdated(updatedFormJson: any[]) {
    this.isZoneChecklistError = false;
    await this.getDataFromLocalDB();
    // this._tempDynamicFormConfig.serverData = [...updatedFormJson];
    // console.log("this._tempDynamicFormConfig.serverData", this._tempDynamicFormConfig.serverData)
  }




  async isFileUploadInProgress() {
    const InspectionFileData: any = await this.idbservice.getTaskFileDetailsToUpload(
      this.taskId, this._appServices.UploadMaxRetryHit, this.orgId
    );
    this._appServices.logsActivity(this._appenum.EntityOfLogLevel.Info,
      'InspectionFileData Self App' + ' ' + JSON.stringify(InspectionFileData), this.componentName);
    return InspectionFileData.length > 0;
  }

  private isAsyncUtilityRunning(): boolean {
    try {
      return this.encryptionService.decrypt(
        this.encryptionService.sessionstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.isRunningAsyncUtility)
      ) === 'true';
    } catch (e) {
      return false;
    }
  }
}   
